import React from "react";
import { render } from "react-dom";
import BaseRouter from "./AppRouter";
import registerServiceWorker from "./registerServiceWorker";
import "./public/index.css";

render(<BaseRouter />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js